import React from 'react';
import './styles.scss';
import Chart from '../../../components/organisms/chart';
import getTotalSalesJSON from './dummyDataRes/getTotalSales.json';

interface Props {
    totalSales: typeof getTotalSalesJSON | undefined;
    totalSalesLoad: boolean;
    overviewSales: {soda: number[], snack: number[], label: string[]} | undefined;
    currentView: number;
    setCurrentView: React.Dispatch<number>;
}

function RenderSalesOverview(props: Props) {
  const {
    totalSales, overviewSales, totalSalesLoad, currentView, setCurrentView,
  } = props;

  const { CustomTopContent } = Chart.Overview;

  return (
    <div className="mb-4">
      <Chart.Overview.Default
        title="Sales Overview"
        topContent={[
          CustomTopContent('Today', 1.5, totalSales?.today?.total?.amount),
          CustomTopContent('This Week', 2.5, totalSales?.['this week']?.total?.amount),
          CustomTopContent('This Month', 3.5, totalSales?.['this month']?.total?.amount),
          CustomTopContent('Yesterday', -0.5, totalSales?.yesterday?.total?.amount),
          CustomTopContent('Last Week', 1.5, totalSales?.['last week']?.total?.amount),
          CustomTopContent('Last Month', 2.5, totalSales?.['last month']?.total.amount),
        ]}
        items={[
          { label: 'Snack', bgColor: 'rgb(225, 143, 80)', amount: overviewSales?.snack ?? [] },
          { label: 'Soda', bgColor: 'rgb(117, 192, 219)', amount: overviewSales?.soda ?? [] },
        ]}
        currentView={currentView}
        setCurrentView={setCurrentView}
        labels={overviewSales?.label ?? []}
        isData={!!overviewSales}
        isLoading={totalSalesLoad}
      />
    </div>
  );
}

export default React.memo(RenderSalesOverview);
